<template>
    <v-text-field
        :required       = "required"
        :rules          = "rules"
        :label          = "$t(label)"
        ref             = "datePicker"
        class           = "datetime-input"
        :class          = "deadline ? 'red-text-input ': '' + color ? color : ''"
        :value          = "fieldvalue"
        :error-messages = "errorMessages"
        autocomplete    = "off"
        autocorrect     = "off"
        autocapitalize  = "off"
        spellcheck      = "false"
        :readonly       = "readonly"
        :disabled       = "readonly"
        :hide-details   = "hideDetails"
        :dense          = "dense"
        :outlined       = "outlined"
        :prepend-icon   = "prependIcon"
        :background-color = "backgroundColor"
    />
</template>

<script>
import $ from 'jquery';
import 'jquery-datetimepicker';
import 'jquery-datetimepicker/build/jquery.datetimepicker.min.css'
import moment from "moment"

export default {
    name: "FDatePicker",
    props: {
        value: {
            required: true
        },
        label: {
            required: false,
        },
        required: {
            required: false,
            default: function () {
                return false;
            }
        },
        rules: {
            required: false
        },
        time: {
            required: false,
            default: function () {
                return false;
            }
        },
        deadline: {
            required: false,
            default: function () {
                return false;
            }
        },
        errorMessages: {
        },

        prependIcon: {
            required: false,
            type    : String,
            default: function () {
                return null;
            }
        },

        readonly: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },

        hideDetails: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },

        dense: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },

        outlined: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },

        color: {
            required: false,
            type    : String,
            default: function () {
                return null;
            }
        },

        backgroundColor: {
            required: false,
            type    : String,
            default: function () {
                return null;
            }
        }
    } ,

    data: () => ({
        fieldvalue   : "",
        formatPicker : null,
        formatDisplay: null,
        formatJson   : null
    }),

    created() {
        this.setFieldvalue ();
    },

    beforeUpdate() {
        this.setFieldvalue ();
    },


    mounted: function () {
        const self = this;
        const el = this.$el;

        $.datetimepicker.setLocale('de');

        const $input = $(el).find('input');
        $input.datetimepicker({
            timepicker: self.time,
            datepicker: true,
            format: self.formatPicker,
            mask: false,
            hour12: false,
            weeks: true,
            scrollMonth : false,
            onChangeDateTime: function (dp, $input) {
                if ($input.val() === undefined || $input.val() === '') {
                    self.$emit('input', "");
                    self.$emit('change', "");
                    return;
                }

                const value = moment($input.val(), self.formatDisplay).format(self.formatJson);
                self.$emit('input', value);
                self.$emit('change', value);
            },
            beforeDestroy: function () {
                $(el).datetimepicker('hide').datetimepicker('destroy');
            }
        });
    },

    watch: {
        value () {
            const el = this.$el;
            const $input = $(el).find('input');
            this.fieldvalue = this.value;
            if (this.value === null || this.value === "") {
                $input.val("");
            } else {
                $input.val(moment( this.value, this.formatJson).format(this.formatDisplay));
            }
        }
    },

    methods: {
        setFieldvalue () {
            if (this.time) {
                this.formatPicker  = "d.m.Y H:i";
                this.formatDisplay = "DD.MM.YYYY HH:mm";
                this.formatJson    = "YYYY-MM-DDTHH:mm:ss";
            } else {
                this.formatPicker  = "d.m.Y";
                this.formatDisplay = "DD.MM.YYYY";
                this.formatJson    = "YYYY-MM-DD";
            }

            if (!this.value || this.value === "") {
                this.fieldvalue = ""
            } else {
                this.fieldvalue = moment( this.value, this.formatJson).format(this.formatDisplay);
            }
        }
    }
}
</script>

<style scoped>


.xdsoft_datetimepicker .xdsoft_label > .xdsoft_select > div > .xdsoft_option.xdsoft_current {
    box-shadow: #178fe5 0 1px 3px 0 inset;
    color: #fff;
    font-weight: 700;
}

::v-deep .xdsoft_datetimepicker .xdsoft_calendar th {
    color: white;
    background-color: red;
}

::v-deep .xdsoft_datetimepicker .xdsoft_calendar td {
    background: white;
    color: black;
}


.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_default,
.xdsoft_datetimepicker .xdsoft_calendar td.xdsoft_current,
.xdsoft_datetimepicker .xdsoft_timepicker .xdsoft_time_box > div > div.xdsoft_current {
    box-shadow: #178fe5 0 1px 3px 0 inset;
    color: #fff;
    font-weight: 700;
}

</style>